module.exports = __webpack_public_path__ + "static/img/zs002.95681fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs002.jpg
// module id = G3dN
// module chunks = 13